import { render, staticRenderFns } from "./wty-template.vue?vue&type=template&id=3d8780be&scoped=true&"
import script from "./wty-template.vue?vue&type=script&lang=js&"
export * from "./wty-template.vue?vue&type=script&lang=js&"
import style0 from "./wty-template.vue?vue&type=style&index=0&id=3d8780be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8780be",
  null
  
)

export default component.exports